<template>
    <div>
        <div class="header">
            <div class="header_t">
                <p class="header_tf">易凡云</p>
                <div class="header_b">
                    <span>提供稳定快速的网络访问服务</span>
                    <span>通过全方位的 CDN 质量监控，以及智能易用的节点调度等功能。</span>
                    <span>保障客户的音视频点播、大文件下载、应用及Web加速服务的稳定及连续性</span>
                </div>
            </div>
            <img src="../assets/imgs/aboutOne.png" class="fruit_img">
        </div>
        <!-- 关于我们 -->
        <div class="bottom_b">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pct">关于我们</div>
                        <div class="product_pc">
                            <span>
                                易凡云是国内专注融合CDN平台研发和智能调度的云厂商，
                                集成各大云厂商资源能力的调度形成各行业的解决方案。通过自主研发平台进行全方位的节点质量监控，
                                以及智能易用的节点调度能力实现秒级切换，在保障客户加速服务的稳定性连续性的基础之上，联动厂商节点时间，
                                实现低成本、高可用的融合方案。业务范围覆盖全国各大省市。
                            </span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 易凡云融合CDN -->
        <div class="center_b">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pct">易凡云融合CDN</div>
                        <div class="product_pc">
                            <div class="product_pc_left">
                                <p>监控体系</p>
                                <span>易凡云自由分布式全网实时监控，结合第三方监控数据、渠道监控数据、客户监控数据，全方位实时监控网络状况。</span>
                            </div>
                            <div class="product_pc_c">
                                <img src="../assets/imgs/aboutThree.png" alt="" class="imgOne">
                                <img src="../assets/imgs/aboutThree.png" alt="" class="imgTwo">
                                <img src="../assets/imgs/aboutThree.png" alt="" class="imgThree">
                            </div>
                            <div class="product_pc_r">
                                <div class="product_pc_right">
                                    <p>管理系统</p>
                                    <span>掌控智能融合CDN平台的运营状态，包括基础数据、资源、统计、质量数据、API体系状况等，透明服务，极致体验。</span>
                                </div>
                                <div class="product_pc_right_b">
                                    <p>智能调度</p>
                                    <span>易凡云基于监控分析系统理论，对可用性故障、节点故障、网络抖动、下载速度、响应时间等异常情形进行节点切换</span>
                                </div>
                            </div>
                        </div>
                        <div class="product_pcts">联系我们</div>
                        <div class="link_b">
                            <div class="link_b_l">
                                <img src="../assets/imgs/aboutSix.png" alt="">
                                <div class="link_b_l_r">
                                    <p>地址</p>
                                    <span>山东省济宁市高新区王因街道海川路69号数字经济创新中心4楼429一2室</span>
                                </div>
                            </div>
                            <div class="link_b_l">
                                <img
                                    src="../assets/imgs/aboutSeive.png"
                                    alt=""
                                    class="link_b_l_rimg"
                                >
                                <div class="link_b_l_r">
                                    <p>成为合作伙伴</p>
                                    <span>企业官网：https://www.yifancloud.cn/</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
  name: "Fruit",
  data() {
    return {};
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.header {
  position: relative;
}
.header .header_t {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 25%;
  left: 34%;
  align-items: center;
animation: header_t 2s;
}

@keyframes header_t {
  0% {
    opacity: 0;
    transform: translate3d( -200%, 0, 0);
  }
}
.header .header_t .header_tf {
  font-size: 40px;
  font-family: MF LiHei (Noncommercial)-Regular, MF LiHei (Noncommercial);
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 5px;
}
.header .header_t .header_b {
  display: flex;
  margin-top: 40px;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 40px;
}
.header .fruit_img {
  height: 376px;
  width: 100%;
}

.bottom_b {
  height: 356px;
}
.bottom_b .product_pc_one {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: product_pc_one 2s;
}
@keyframes product_pc_one {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.bottom_b .product_pc_one .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 80px 0 28px 0;
}
.bottom_b .product_pc_one .product_pc {
  width: 1146px;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 40px;
}
.center_b {
  height: 1284px;
  background: #f5f7fd;
}
.center_b .product_pc_one {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.center_b .product_pc_one .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 80px 0 91px 0;
}
.center_b .product_pc_one .product_pc {
  display: flex;
  width: 1221px;
  justify-content: space-evenly;
}
.center_b .product_pc_one .product_pc .product_pc_left {
  background-image: url("../assets/imgs/aboutTwo.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 577px;
  height: 138px;
  position: relative;
  margin-top: 157px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  animation: product_pc_left 2s;
}

@keyframes product_pc_left {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.center_b .product_pc_one .product_pc .product_pc_left p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #0066ff;
  line-height: 18px;
  margin: 0 33px 12px 0;
}
.center_b .product_pc_one .product_pc .product_pc_left span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #848b99;
  line-height: 28px;
  width: 519px;
  margin-right: 19px;
}
.center_b .product_pc_one .product_pc .product_pc_c {
  width: 0px;
  height: 459px;
  opacity: 1;
  border-right: 4px solid #0167ff;
  position: relative;
}
.center_b .product_pc_one .product_pc .product_pc_c .imgOne {
  position: absolute;
  top: 79px;
  left: -10px;
}
.center_b .product_pc_one .product_pc .product_pc_c .imgTwo {
  position: absolute;
  top: 214px;
  left: -10px;
}
.center_b .product_pc_one .product_pc .product_pc_c .imgThree {
  position: absolute;
  top: 354px;
  left: -10px;
}
.center_b .product_pc_one .product_pc .product_pc_r .product_pc_right {
  background-image: url("../assets/imgs/aboutFour.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 577px;
  height: 138px;
  position: relative;
  margin-top: 21px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  animation: product_pc_right 2s;
}

@keyframes product_pc_right {
  0% {
    opacity: 0;
    transform: translate3d(0,-100%, 0);
  }
}
.center_b .product_pc_one .product_pc .product_pc_r .product_pc_right p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #0066ff;
  line-height: 18px;
  margin: 0 0 12px 33px;
}
.center_b .product_pc_one .product_pc .product_pc_r .product_pc_right span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #848b99;
  line-height: 28px;
  width: 519px;
  margin-left: 33px;
}
.center_b .product_pc_one .product_pc .product_pc_r .product_pc_right_b {
  background-image: url("../assets/imgs/aboutFour.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 577px;
  height: 138px;
  position: relative;
  margin-top: 138px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  animation: product_pc_right_b 2s;
}

@keyframes product_pc_right_b {
  0% {
    opacity: 0;
    transform: translate3d(0,-100%, 0);
  }
}
.center_b .product_pc_one .product_pc .product_pc_r .product_pc_right_b p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #0066ff;
  line-height: 18px;
  margin: 0 0 12px 33px;
}
.center_b .product_pc_one .product_pc .product_pc_r .product_pc_right_b span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #848b99;
  line-height: 28px;
  width: 519px;
  margin-left: 33px;
}
.center_b .product_pc_one .product_pcts {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 149px 0 89px 0;
}
.center_b .product_pc_one .link_b {
  width: 1350px;
  display: flex;
  flex-direction: row;
}
.center_b .product_pc_one .link_b .link_b_l {
  width: 630px;
  height: 197px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 28px;
  padding-right: 31px;
  animation: link_b_l 2s;
}

@keyframes link_b_l {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.center_b .product_pc_one .link_b .link_b_l img {
  width: 102px;
  height: 102px;
  margin: 0 24px 0 31px;
}
.center_b .product_pc_one .link_b .link_b_l .link_b_l_rimg {
  width: 102px;
  height: 102px;
  margin: 0 24px 0 119px;
  animation: link_b_l_rimg 2s;
}
@keyframes link_b_l_rimg {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.center_b .product_pc_one .link_b .link_b_l_r p {
  font-size: 24px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 24px;
  margin-bottom: 16px;
}
.center_b .product_pc_one .link_b .link_b_l_r span {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 40px;
  width: 473px;
}
</style>